module.exports = __webpack_public_path__ + "static/media/mobileIcon.6838a9fb.svg";